export const calcWeightedPercent = <T>(rows: T[], valueKey: keyof T, salesKey: keyof T) => {
  let weightedSum = 0
  let weight = 0

  rows.forEach((row) => {
    const value = row[valueKey] as unknown as number
    const sales = (row[salesKey] as unknown as number) || 1

    if (value) {
      weightedSum += sales / (value / 100)
      weight += sales
    }
  })

  return weight > 0 ? (weight / weightedSum) * 100 : 0
}
